import React from 'react';
import { ChevronDown } from '@design-systems/icons';
import { ClusterLayout } from '@mc/wink';
import { getCountryUnicodeFlag } from '../utils/helpers';

// Types based on the actual data structure
export interface SmsProgramData {
  countryCode: string;
  countryCallingCode: string;
  number: string;
  imgSrc: string;
  requiredTemplate: string;
  optionalTemplate: string;
}

export interface CountryName {
  code: string;
  name: string;
}

export interface LegalText {
  required: string;
  optional: string;
}

export interface ContactFormField {
  id: string;
  name: string;
  required?: boolean;
}

export interface MergeField {
  choices: string[];
  components: string[];
  countryNames?: CountryName[];
  dateformat?: string;
  legal: LegalText;
  smsProgramData: SmsProgramData[];
  defaultCountryCode?: string;
  id: number;
  name: string;
  type: string;
}

export interface Destination {
  type: 'merge_field';
  id: number;
  name: string;
  smsProgramData: SmsProgramData[];
  defaultCountryCode: string;
  countryNames: CountryName[];
  legal: LegalText;
}

export interface FormSmsField {
  id: number;
  isRequired: boolean;
  label: string;
  helpText: string;
  helpTextEnabled: boolean;
  destination: {
    type: string;
    id: number;
  };
}

interface MultiCountrySmsInputProps {
  field: FormSmsField;
  destination: Destination;
  selectedCountry?: string;
  onCountryChange: (country: string) => void;
}

const MultiCountrySmsInput: React.FC<MultiCountrySmsInputProps> = ({
  field,
  destination,
  selectedCountry,
  onCountryChange,
}) => {
  return (
    <ClusterLayout>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            cursor: 'pointer',
            position: 'relative',
          }}
        >
          <span>{getCountryUnicodeFlag(selectedCountry || '')}</span>
          <ChevronDown size="xsmall" />
          <select
            name={`fields.${field.id}[country]`}
            value={selectedCountry}
            onChange={(e) => onCountryChange(e.target.value)}
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              opacity: '0',
              cursor: 'pointer',
              zIndex: '10',
              border: 'none',
              background: 'transparent',
              fontSize: '0',
              margin: '0',
              padding: '0',
              minWidth: 'auto',
              maxWidth: 'none',
            }}
          >
            {destination?.smsProgramData?.map(
              (program: SmsProgramData, index: number) => {
                const countryName =
                  destination?.countryNames?.find(
                    (country: CountryName) =>
                      country.code === program.countryCode,
                  )?.name || program.countryCode;

                return (
                  <option key={index} value={program.countryCode}>
                    {countryName} {program.countryCallingCode}
                  </option>
                );
              },
            )}
          </select>
        </div>
      </div>
    </ClusterLayout>
  );
};

export default MultiCountrySmsInput;
